import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './app.css';

import { routes } from './Components/Menu';
import MainLayout from './Components/BaseLayout/MainLayout';
import CssBaseline from '@material-ui/core/CssBaseline';
import PoliticasPrivacidadePage from './Pages/PoliticaPrivacidadePage/PoliticaPrivacidadePage';
import { useSessao } from './redux/sessao/sessaoHooks';
import LoginPage from './Pages/LoginPage/LoginPage';
import LinkPagamentoPage from './Pages/LinkPagamento/LinkPagamentoPage';

function App() {
  const [sessao] = useSessao();

  return (
    <>
      <ToastContainer style={{ marginTop: 'env(safe-area-inset-top, 0px)' }} />
      <CssBaseline />

      <BrowserRouter>
        <Routes>
          <Route path="/cobranca/:id" element={<LinkPagamentoPage />} />
          <Route path="/politica-privacidade" element={<PoliticasPrivacidadePage />} />

          <Route path="/login" element={sessao?.token ? <Navigate to="/" /> : <LoginPage />} />

          <Route path="/" element={sessao?.token ? <MainLayout /> : <Navigate to="/login" />}>
            {routes}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
